
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_oip5a_160mh_5"
};
  